import styled from 'styled-components'

const StyledContainer = styled.div`
  padding: 12px 36px 36px 36px;
`

const StyledHeader = styled.h3`
  margin-bottom: 0;
  padding: 8px 0;
  font-size: 1.6rem;
`

const StyledTitle = styled.h2`
  padding-bottom: 16px;
  margin-bottom: 0;
  font-weight: 800;
`

interface IProps {
  header?: string
  title?: string
  videoId?: string
}
const VideoModal = (props: IProps) => {
  const { header, title, videoId } = props
  return (
    <StyledContainer>
      <StyledHeader>{header}</StyledHeader>
      <StyledTitle>{title}</StyledTitle>
      <iframe
        width={'100%'}
        height={428}
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=1&origin=https%3A%2F%2https://clinic.amaz.com.vn/&playsinline=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&enablejsapi=1&widgetid=5`}
        title={title}
        frameBorder={0}
        id="widget6"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </StyledContainer>
  )
}
export default VideoModal
